import { put } from '@uipath/portal-shell-util';

import { Account } from '../../models/account';
import { ITrialUpgradeDto } from '../../models/upgradeToTrial';
import Logger from '../logger/logger';

export async function upgradeToTrial(
    organizationStandardUrl: string,
    token: string,
    accountUserId: string,
    accountGlobalId: string,
    contactInfo: ITrialUpgradeDto,
): Promise<Account | undefined> {
    const accountUrl = `${organizationStandardUrl}/portal_/api/licensing/trial`;

    Logger.debug('api', 'upgrading to trial');
    return put(
        accountUrl,
        {
            token,
            body: {
                accountUserId,
                accountGlobalId,
                contactInfo,
            },
        },
        (e, method, url, requestProps) => {
            Logger.warn('api', `unexpected error happened on upgrade to trial API call: ${e}`, {
                object: {
                    method,
                    url,
                    requestProps,
                    hasToken: !!token,
                },
                stack: e.stack,
            });
        },
    );
}
